import { StudentData } from "../../student/models/student-data.model";

export class FamilyForm {
    familyId: number;
    familyName: string;
    firstName: string;
    lastName: string;
    bankAccount1: string;
    bankAccount2: string;
    bankAccount3: string;
    bankAccount4: string;
    bankAccount5: string;
    bankAccount6: string;
    customerKey: string;
    oracleNumber: number;
    identification: string;
    customerName: string;
    isAmpa: boolean;
    schoolName: string;
    address: string;
    city: string;
    province: string;
    email: string;
    zipCode: string;
    sendInvoiceByEmail: boolean;
    phone: string;
    mobilePhone: string;
    debt: number;
    debtStateId: number;
    debtYearId: number;
    languageId: number;
    familyDocumentType: number;
    isActive: boolean;
    schoolId: number;
    familyStudents: StudentData[];
  }
  